var $ = jQuery.noConflict();

// Cita Form Select
let cliente_button = $("#is_cliente");
let cliente_form = $("#cliente_form");
let primarvisita_button = $("#is_primaravisita");
let primarvisita_form = $("#primera_visita_form");

cliente_button.click(function(){
       cliente_form.removeClass("hide-form");
       primarvisita_form.addClass("hide-form");
});

primarvisita_button.click(function(){
       cliente_form.addClass("hide-form");
       primarvisita_form.removeClass("hide-form");
});